import Month from "./CalendarViewMonth"
import type { MonthType } from "./types"

type Props = {
  months: MonthType[]
  isSundayFirstDayOfWeek?: boolean
}

const CalendarView = ({ months, isSundayFirstDayOfWeek }: Props) => (
  <div className="cobalt-CalendarView">
    {months.map((month) => (
      <Month
        key={month.monthStart}
        isSundayFirstDayOfWeek={isSundayFirstDayOfWeek}
        {...month}
      />
    ))}
  </div>
)

CalendarView.displayName = "CalendarView"

export { CalendarView }
